import { ConversationSummary } from '../core/hub-types';
import { isStateModeGroup } from '../../shared/util/state-mode.util';

/**
 * The chats a state unit (tasks/state-mode.md) does not have: with patients through the patient app, with referring or
 * referred clinicians, with colleagues in other practices, and with a MedicAI Connect billing team. Its own team's
 * chats, chats about a patient and MedicAI support stay.
 */
export const OUTSIDE_TYPES: readonly ConversationSummary['type'][] = ['patient_direct', 'referral', 'network', 'billing'];

/** The ids of the user's practices that are state units. */
export function stateUnitGroupIds(groups: { id: string; stateMode?: boolean }[] | null | undefined): Set<string> {
  return new Set((groups ?? []).filter((g) => isStateModeGroup(g)).map((g) => g.id));
}

/** Whether a conversation is shown: never one of OUTSIDE_TYPES at a state unit. Chat is per practice (org). */
export function visibleInStateMode(c: ConversationSummary, unitGroupIds: Set<string>, groupIdOfOrg: (orgId: string) => string | null): boolean {
  if (!unitGroupIds.size || !OUTSIDE_TYPES.includes(c.type)) return true;
  const groupId = groupIdOfOrg(c.orgId);
  return !(groupId && unitGroupIds.has(groupId));
}
